import { Typography, useTheme, useMediaQuery } from "@mui/material";
import { sectionTitleStyle } from "./CouponStyles";

export const SectionTitle: React.FC<{ children: string }> = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Typography sx={{
      ...sectionTitleStyle,
      fontSize: isMobile ? '22px' : '30px',
      mt: isMobile ? 1 : 0
    }}>
      {children}
    </Typography>
  );
};  














